var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('a',{staticClass:"logo",attrs:{"href":"/"}},[_c('img',{staticClass:"d-inline-block align-top",attrs:{"src":_vm.$store.state.campaign.logo || 'static/svg/logo-small-squared.svg',"alt":_vm.$store.state.campaign.name}})])])}
var staticRenderFns = []

export { render, staticRenderFns }